import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "change-price-wrapper" }
const _hoisted_2 = { class: "form-group" }
const _hoisted_3 = { class: "action-buttons" }

import { reactive } from "vue";
  import { trans } from "@/utils/trans";
  import { useToast } from "primevue/usetoast";
  import { useAuctionStore } from "@/stores/AuctionStore";
  import apiClient from "@/services/api";
  import { isObject } from "lodash";
  import { SelectBidDropdown } from "@/components/_partials/lot-info-popup";

  
export default /*#__PURE__*/_defineComponent({
  __name: 'ChangePricePopup',
  setup(__props) {

  const toast = useToast();
  const auctionStore = useAuctionStore();

  const state = reactive({
    changePriceAmount: 0
  });

  const onPriceChange = (nv) => {
    state.changePriceAmount = nv;
  };

  const save = () => {
    apiClient
      .post("/api/lots/" + auctionStore.activeLot.id + "/update-current-bid", {
        amount: state.changePriceAmount
      })
      .then((response) => {
        if (response.data.success) {
          toast.add({
            severity: "success",
            summary: trans("live.toast.success"),
            detail: trans("live.toast.lot.price_changed"),
            life: 6000
          });
          state.changePriceAmount = null;
        }
      })
      .catch((error) => {
        if (isObject(error.response.data?.errors)) {
          const errors = [] as string[];
          Object.values(error.response.data.errors).forEach((itemErrors) => {
            errors.push(...itemErrors);
          });

          errors.forEach((error: string) => {
            toast.add({
              severity: "error",
              summary: trans("live.toast.error"),
              detail: error || trans("live.toast.unknown_error"),
              life: 6000
            });
          });
        }
      });
  };

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_unref(SelectBidDropdown), {
        "lot-data": _unref(auctionStore).activeLot,
        "user-bid-prop": _unref(auctionStore).activeLot.current_bid,
        "current-bid-prop": _unref(auctionStore).activeLot.current_bid,
        "bids-count-prop": _unref(auctionStore).activeLot.bids_count,
        "onUpdate:selectedBid": onPriceChange
      }, null, 8, ["lot-data", "user-bid-prop", "current-bid-prop", "bids-count-prop"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("button", {
        class: "btn btn-blue",
        onClick: save
      }, _toDisplayString(_unref(trans)("live.modals.change_price.confirm_button")), 1)
    ])
  ]))
}
}

})